import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  IconButton,
  Button,
  Slide,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  useTheme,
  ThemeProvider,
  createTheme,
  FormHelperText,
  Typography,
  Grid2,
} from "@mui/material";
import styles from "../styles/AddEditUserModal.module.css";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Checkbox from "@mui/material/Checkbox";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useMutation, useQuery } from "react-query";
import axios from "../utilis/axios";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "../store";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import Popper from "@mui/material/Popper";
import { useLocation, useParams } from "react-router-dom";
import { useGetAllRoleQuery } from "store/slices/apis/rolePackageSlice";
import { useGetUserByEmailQuery } from "store/slices/apis/userSlice";

const checkBoxIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkBoxCheckedIcon = <CheckBoxIcon fontSize="small" />;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const fetchUserById = async (id) => {
  try {
    const response = await axios.get(`/account/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

const fetchRoles = async () => {
  try {
    const response = await axios.get("Roles");
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

const createUser = async (userData) => {
  try {
    const response = await axios.post("account/create", userData);
    return response.data;
  } catch (error) {
    throw new Error(error.value || "Something went wrong");
  }
};
const credentialTypes = [{name:"Username & Password",value:"username"},{name:"SSO",value:"sso"}];
const updateUser = async (userData) => {
  try {
    const response = await axios.put("account/update", userData);
    return response.data;
  } catch (error) {
    throw new Error(error.value || "Something went wrong");
  }
};

const AddEditUserModal = ({ open, handleClose, user, onSubmit, type }) => {
  const { projectId } = useParams();
  const newtheme = useTheme();
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const location = useLocation();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    designation: "",
    phoneNumber: "",
    roles: [],
    projects: [],
    oid:"",
    loginMethod:""
  });
  const [emailToCheck, setEmailToCheck] = useState("");
  const [emailCheckTriggered, setEmailCheckTriggered] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [showExistingUserDialog, setShowExistingUserDialog] = useState(false);
  const [isExistingUser, setIsExistingUser] = useState(false);

  const { data: userData } = useQuery(
    ["getUserById", user?.id],
    () => fetchUserById(user?.id),
    {
      enabled: !!user?.id,
    }
  );

  // const { data: rolesData } = useQuery("getRoles", fetchRoles(projectId));
  const { data: rolesData, isLoading } = useGetAllRoleQuery(
    projectId != undefined && (
      { projectId: projectId }
    )
  );
  const { data: AllProjects = [], error, refetch } = useGetAllProjectsQuery();
  const {
    data: userInfo,
    error: userInfoError,
    isFetching,
    isSuccess,
  } = useGetUserByEmailQuery(emailToCheck, {
    skip: !emailCheckTriggered || !emailToCheck,
  });


  const handleEmailBlur = async (e) => {
    const value = e.target.value.trim();
    if (!value) return;

    setEmailToCheck(value);
    setEmailCheckTriggered(true);
  };
  useEffect(() => {
    if (!emailCheckTriggered || isFetching) return;

    if (userInfo && isSuccess && !userInfoError) {
      setShowExistingUserDialog(true);
    }
    if (userInfoError && userInfoError?.originalStatus === 404) {
      setIsReadOnly(false);
      setIsExistingUser(false);
      setShowExistingUserDialog(false);
      formikRef.current.setValues({
        firstName: "",
        lastName: "",
        email: emailToCheck,
        designation: "",
        phoneNumber: "",
        roles: [],
        projects: [],
        oid:"",
        loginMethod:""
      });
    }
  }, [userInfo, userInfoError, isSuccess, isFetching, emailCheckTriggered]);



  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            borderRadius: "4px",
            marginTop: "16px",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              color: "#696969",
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
              color: "#252525",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
            "& .MuiAutocomplete-tag": {
              margin: "10px 3px 5px 3px !important",
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          option: {
            '&[aria-selected="true"]': {
              backgroundColor: "transparent",
            },

            "&:hover": {
              backgroundColor: "transparent",
            },
          },
        },
      },
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  const createUserMutation = useMutation(createUser, {
    onSuccess: (response) => {
      openNotification(
        response?.message || "User created successfully",
        "success"
      );
      handleCloseModal();
    },
    onError: (error) => {
      openNotification(error?.message || "Something went wrong");
    },
  });

  const updateUserMutation = useMutation(updateUser, {
    onSuccess: (response) => {
      openNotification(response?.msg || "User updated successfully", "success");
      handleCloseModal();
    },
    onError: (error) => {
      openNotification(error?.message || "Something went wrong");
    },
  });

  useEffect(() => {
    if (userData) {
      setFormData({
        firstName: userData?.firstName || "",
        lastName: userData?.lastName || "",
        email: userData?.email || "",
        designation: userData?.designation || "",
        phoneNumber: userData?.phoneNumber || "",
        roles: userData?.roleName || [],
        projects: userData?.projects || [],
        oid:userData?.oid || "",
        loginMethod:userData?.loginMethod ||""
      });
    }
  }, [userData]);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .matches(
        /^(?!\d+$)[A-Za-z0-9\s]+$/,
        "First Name doesn't only contain numbers"
      )
      .required("Please enter First Name"),

    lastName: Yup.string()
      .matches(
        /^(?!\d+$)[A-Za-z0-9\s]+$/,
        "Last Name doesn't only contain numbers"
      )
      .required("Please enter Last Name"),

    designation: Yup.string().required("Please enter Designation"),

    email: Yup.string()
      .email("Invalid email format")
      .required("Please enter a valid email address"),

    phoneNumber: Yup.string()
      .matches(/^\+\d{12,15}$/, "Please remember to include country code")
      .required("Phone Number is required"),

    // roles: Yup.array().min(1, "Please select a role"),
    roles: Yup.array().when('$projectId', {
      is: (projectId) => projectId !== undefined, // when projectId is undefined
      then: (schema) => schema.min(1, "Please select a role"), // required
      otherwise: (schema) => schema.notRequired(), // not required
    }),
    //oid:Yup.string().required("SSO Object Id is required"),
    loginMethod: Yup.string().required("Login Method is required."),
    oid: Yup.string()
    .when('$loginMethod', {
      is: "sso",
      then: (schema) =>
        schema.required("SSO Object Id is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    
  });

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: { color: type },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 10000);
  };

  const handleSubmit = async (values) => {
    const submittedValues = {
      Email: values.email?.trim(),
      FirstName: values.firstName?.trim(),
      LastName: values.lastName?.trim(),
      Designation: values.designation?.trim(),
      PhoneNumber: values.phoneNumber,
      RoleName: values.roles,
      Projects: projectId ? [projectId] : values.projects,
      IsProjectUser: projectId ? true : false,
      Oid:values.oid?.trim(),
      LoginMethod:values.loginMethod?.trim()
    };
    
    if (user?.id || isExistingUser) {
      submittedValues.id = user?.id || userInfo?.id;
      await updateUserMutation.mutateAsync(submittedValues);
    } else {
      await createUserMutation.mutateAsync(submittedValues);
    }
    onSubmit();
  };

  const handleCloseModal = () => {
    formikRef.current?.resetForm();
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      designation: "",
      phoneNumber: "",
      roles: [],
      projects: [],
    });
    setIsReadOnly(false);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleCloseModal();
        }
      }}
      aria-describedby="add-user-modal-description"
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "550px",
          width: "100%",
        },
      }}
    >
      <DialogTitle>
        <h3 className={styles.heading}>
          {userData ? "Edit user details" : "Add user details"}
        </h3>
        <IconButton
          sx={{ position: "absolute", right: 8, top: 8 }}
          onClick={handleCloseModal}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Formik
        innerRef={formikRef}
        initialValues={formData}
        validationSchema={validationSchema}
        validationContext={{ projectId }}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          setFieldValue,
          setTouched,
        }) => (
          <>
            <Form>
              <DialogContent
                sx={{
                  padding: "0px 24px 20px 24px",
                }}
              >
                <ThemeProvider theme={theme}>
                  <TextField
                    label={
                      <span>
                        Work Email{" "}
                        <span style={{ color: "#C52A1A", fontSize: "20px" }}>
                          *
                        </span>
                      </span>
                    }
                    name="email"
                    value={values.email}
                    onChange={(e) => {
                      handleChange(e);
                      setEmailCheckTriggered(false);
                      setIsReadOnly(false);
                      setIsExistingUser(false);
                      setShowExistingUserDialog(false);
                      setEmailToCheck("");
                    }}
                    onBlur={handleEmailBlur}
                    disabled={!!userData}
                    fullWidth
                    variant="filled"
                  />
                  {touched?.email && errors?.email && (
                    <FormHelperText
                      sx={{ color: "#C52A1A", fontSize: "12px" }}
                    >{`${errors?.email}`}</FormHelperText>
                  )}
                  <Dialog
                    open={showExistingUserDialog}
                    TransitionComponent={Transition}
                    onClose={(event, reason) => {
                      if (reason !== "backdropClick") {
                        setShowExistingUserDialog(false);
                      }
                    }}
                    sx={{
                      "& .MuiDialog-paper": {
                        maxWidth: "380px",
                        width: "100%",
                        minHeight: "220px"
                      },
                    }}
                  >
                    <DialogTitle>User Already Exists</DialogTitle>
                    <DialogContent
                      sx={{
                        padding: "10px 25px !important",
                      }}
                    >
                      <Typography>A user associated with this Email ID already exists in this project or some other project. Do you want to continue?</Typography>
                    </DialogContent>
                    <DialogActions
                      sx={{
                        marginBottom: "20px",
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={() => {
                          formikRef.current.setValues({
                            firstName: "",
                            lastName: "",
                            designation: "",
                            phoneNumber: "",
                            roles: [],
                            projects: [],
                          });
                          setShowExistingUserDialog(false);
                          setIsReadOnly(false);
                        }}
                        sx={{
                          border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                          color: newtheme?.customSettings?.themeColor,
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "24px",
                          textTransform: "none",
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => {
                          formikRef.current.setValues({
                            firstName: userInfo.firstName || "",
                            lastName: userInfo.lastName || "",
                            email: userInfo.email || "",
                            designation: userInfo.designation || "",
                            phoneNumber: userInfo.phoneNumber || "",
                            roles: [],
                            projects: [],
                          });
                          setIsReadOnly(true);
                          setShowExistingUserDialog(false);
                          setIsExistingUser(true);
                        }}
                        sx={{
                          backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                          border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                          color: "#fff",
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "24px",
                          marginRight: "20px",
                          textTransform: "none",
                        }}
                      >
                        OK
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <TextField
                    label={
                      <span>
                        First Name{" "}
                        <span style={{ color: "#C52A1A", fontSize: "20px" }}>
                          *
                        </span>
                      </span>
                    }
                    name="firstName"
                    value={values.firstName}
                    onChange={handleChange}
                    fullWidth
                    disabled={isFetching || isReadOnly}
                    // error={touched.firstName && Boolean(errors.firstName)}
                    // helperText={touched.firstName && errors.firstName}
                    variant="filled"
                    onBlur={() => setTouched({ ...touched, firstName: true })}
                  />
                  {touched?.firstName && errors?.firstName && (
                    <FormHelperText
                      sx={{ color: "#C52A1A", fontSize: "12px" }}
                    >{`${errors?.firstName}`}</FormHelperText>
                  )}
                  <TextField
                    label={
                      <span>
                        Last Name{" "}
                        <span style={{ color: "#C52A1A", fontSize: "20px" }}>
                          *
                        </span>
                      </span>
                    }
                    name="lastName"
                    value={values.lastName}
                    onChange={handleChange}
                    fullWidth
                    disabled={isFetching || isReadOnly}
                    variant="filled"
                    onBlur={() => setTouched({ ...touched, lastName: true })}
                  />
                  {touched?.lastName && errors?.lastName && (
                    <FormHelperText
                      sx={{ color: "#C52A1A", fontSize: "12px" }}
                    >{`${errors?.lastName}`}</FormHelperText>
                  )}
                  <TextField
                    label={
                      <span>
                        Designation{" "}
                        <span style={{ color: "#C52A1A", fontSize: "20px" }}>
                          *
                        </span>
                      </span>
                    }
                    name="designation"
                    value={values.designation}
                    onChange={handleChange}
                    fullWidth
                    disabled={isFetching || isReadOnly}
                    variant="filled"
                    onBlur={() => setTouched({ ...touched, designation: true })}
                  />
                  {touched?.designation && errors?.designation && (
                    <FormHelperText
                      sx={{ color: "#C52A1A", fontSize: "12px" }}
                    >{`${errors?.designation}`}</FormHelperText>
                  )}
                  <TextField
                    label={
                      <span>
                        Phone Number{" "}
                        <span style={{ color: "#C52A1A", fontSize: "20px" }}>
                          *
                        </span>
                      </span>
                    }
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    fullWidth
                    disabled={isFetching || isReadOnly}
                    variant="filled"
                    onBlur={() => setTouched({ ...touched, phoneNumber: true })}
                  />
                  <FormHelperText
                    sx={{
                      color:
                        touched?.phoneNumber && errors?.phoneNumber
                          ? "#C52A1A"
                          : "#474747",
                      fontSize: "12px",
                    }}
                  >
                    {"Please remember to include country code"}
                  </FormHelperText>
                  {location?.pathname === "/user-management/user-list" && (
                    <Autocomplete
                      multiple
                      options={AllProjects?.data || []}
                      getOptionLabel={(option) => option.project_name}
                      disableCloseOnSelect
                      value={
                        AllProjects?.data?.filter(
                          (project) =>
                            Array.isArray(values.projects) &&
                            values.projects.includes(project.project_id)
                        ) || []
                      }
                      onChange={(e, value) => {
                        setFieldValue(
                          "projects",
                          value.map((project) => project.project_id)
                        );
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li
                          key={option.project_id}
                          {...props}
                          style={{ whiteSpace: "nowrap", marginBottom: "5px" }}
                        >
                          <Checkbox
                            icon={checkBoxIcon}
                            checkedIcon={checkBoxCheckedIcon}
                            checked={selected}
                            sx={{
                              height: "16px",
                              width: "16px",
                              marginRight: "5px",
                              color: newtheme?.customSettings?.themeColor,
                              "&.Mui-checked": {
                                color: newtheme?.customSettings?.themeColor,
                              },
                            }}
                          />
                          {option.project_name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={<span>Select Projects </span>}
                          variant="filled"
                        />
                      )}
                      ListboxProps={{
                        style: {
                          fontSize: "16px",
                          lineHeight: "24px",
                          fontWeight: 400,
                        },
                      }}
                      PopperComponent={(props) => (
                        <Popper {...props} placement="bottom-start" />
                      )}
                    />
                  )}
                  {projectId != undefined &&
                    <Autocomplete
                      multiple
                      options={rolesData?.data || []}
                      getOptionLabel={(option) => option.displayName}
                      disableCloseOnSelect
                      value={
                        rolesData?.data?.filter((role) =>
                          values.roles.includes(role.name)
                        ) || []
                      }
                      onChange={(e, value) => {
                        setFieldValue(
                          "roles",
                          value.map((role) => role.name)
                        );
                      }}
                      onBlur={() => setTouched({ ...touched, roles: true })}
                      renderOption={(props, option, { selected }) => (
                        <li
                          key={option.name}
                          {...props}
                          style={{ whiteSpace: "nowrap", marginBottom: "5px" }}
                        >
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon />}
                            checkedIcon={<CheckBoxIcon />}
                            checked={selected}
                            sx={{
                              height: "16px !important",
                              width: "16px !important",
                              marginRight: "5px",
                              color: newtheme?.customSettings?.themeColor,
                              "&.Mui-checked": {
                                color: newtheme?.customSettings?.themeColor,
                              },
                              "& svg": {
                                width: "20px",
                                height: "20px",
                              },
                            }}
                          />
                          {option.displayName}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <span>
                              Select Roles{" "}
                              <span
                                style={{ color: "#C52A1A", fontSize: "16px" }}
                              >
                                *
                              </span>
                            </span>
                          }
                          variant="filled"
                        />
                      )}
                      ListboxProps={{
                        style: {
                          fontSize: "16px",
                          lineHeight: "24px",
                          fontWeight: 400,
                        },
                      }}
                      PopperComponent={(props) => (
                        <Popper {...props} placement="bottom-start" />
                      )}
                      groupBy={() => "Select Roles"}
                      renderGroup={(params) => (
                        <div>
                          <div
                            style={{
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "20px",
                              background: "#F3F3F3",
                              padding: "4px 8px",
                              margin: "5px",
                              borderRadius: "5px",
                              color: "#474747",
                            }}
                          >
                            {params.group}
                          </div>
                          <span
                            style={{
                              fontSize: "16px",
                              lineHeight: "24px",
                              fontWeight: 400,
                              color: "#474747",
                            }}
                          >
                            {params.children}
                          </span>
                        </div>
                      )}
                    />
                  }
                  {touched?.roles && errors?.roles && projectId != undefined && (
                    <FormHelperText
                      sx={{ color: "#C52A1A", fontSize: "12px" }}
                    >{`${errors?.roles}`}</FormHelperText>
                  )}

                  <Grid2 size={{ xs: 12, md: 6 }}>
                        <Autocomplete
                          options={credentialTypes}
                          getOptionLabel={(option) => option.name}
                          value={
                            credentialTypes.find(
                              (option) => option.value === values.loginMethod
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "loginMethod",
                              newValue ? newValue.value : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, loginMethod: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Login Method"
                              name="Login Method"
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.loginMethod && errors?.loginMethod && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.loginMethod}`}</FormHelperText>
                        )}
                      </Grid2>  
                      {values?.loginMethod == "sso" &&
                        <>
                        <TextField
                          label={
                            <span>
                              SSO Object Id{" "}
                              <span style={{ color: "#C52A1A", fontSize: "20px" }}>
                                *
                              </span>
                            </span>
                          }
                          name="oid"
                          value={values.oid}
                          onChange={handleChange}
                          fullWidth
                          disabled={isFetching || isReadOnly}
                          variant="filled"
                          onBlur={() => setTouched({ ...touched, oid: true })}
                        />
                        {touched?.oid && errors?.oid && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.oid}`}</FormHelperText>
                        )}
                        </>
                      }
                </ThemeProvider>
              </DialogContent>
              <DialogActions
                sx={{
                  marginBottom: "20px",
                }}
              >
                <Button
                  onClick={handleCloseModal}
                  variant="outlined"
                  sx={{
                    border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                    color: newtheme?.customSettings?.themeColor,
                    fontSize: "16px",
                    fontWeight: 500,
                    lineHeight: "24px",
                    textTransform: "none",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                    border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: 500,
                    lineHeight: "24px",
                    marginRight: "20px",
                    textTransform: "none",
                  }}
                >
                  Save
                </Button>
              </DialogActions>
            </Form>
          </>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddEditUserModal;
